class Draggable {
	constructor(){
		this.parentNode=null;
		this.active=false;
		this.dragElm=null;
		this.siblings=null;
		this.oldIndex=null;
		this.newIndex=null;
		this.placeholderIndex=null;
		this.observers = [];

		document.addEventListener('mousemove',e=>this.handleDragMove(e));
		document.addEventListener('mousedown',e=>this.handleDragStart(e));
		document.addEventListener('mouseup',e=>this.handleDragEnd(e));

	}

  subscribe(fn) {
		if(!this.observers) this.observers = [];
    this.observers.push(fn);
  }
  unsubscribe(fn) {
		if(!this.observers) return;
    this.observers = this.observers.filter(subscriber => subscriber !== fn);
  }
  notify(data) {
		if(!this.observers) return;
    this.observers.forEach(fn => fn(data));
  }

	handleDragStart(e){
		if(!e.target.matches('[draggable] .handle')) return;
		this.dragElm = e.target.closest('[draggable]');
		this.parentNode = this.dragElm.parentNode;
		this.siblings = [...this.parentNode.children];
		if(this.siblings.length<2) return;
		this.active = true;
		this.oldIndex = this.siblings.indexOf(this.dragElm);
		this.newIndex = this.oldIndex;
		this.placeholderIndex = null;

		this.dragElm.classList.add('dragging');

		this.movePlaceholder(this.oldIndex);
		this.handleDragMove(e);
	}


	handleDragMove(e){
		if(!this.active) return;
		e.preventDefault();
		var clientY = e.clientY;
		this.dragElm.style.top = clientY+'px';

		var rect, x;
		this.newIndex = 0;
		for(x=0;x<this.siblings.length;x++){
			var rect = this.siblings[x].getBoundingClientRect();
			if(clientY<rect.y+rect.height/2) {
				this.newIndex = x;
				break;
			}
			this.newIndex = x+1;
		}
		this.movePlaceholder(this.newIndex);
	}

	handleDragEnd(e){
		if(!this.active) return;
		this.active = false;

		var placeholder = this.parentNode.querySelector('.placeholder');
		if(placeholder) this.parentNode.removeChild(placeholder);

		this.dragElm.classList.remove('dragging');
		this.dragElm.style.top = '';
		this.dragElm.style.left = '';
		if(this.oldIndex==this.newIndex || this.oldIndex==this.newIndex-1){
			return;
		}
		//this.callback(this.parentNode,this.oldIndex,this.newIndex);

		this.notify([this.parentNode,this.oldIndex,this.newIndex]);
	}
	movePlaceholder(newIndex){
		if(this.placeholderIndex==newIndex) return;

		this.placeholderIndex = newIndex;

		var placeholder = this.parentNode.querySelector('.placeholder')
		if(!placeholder) {
			placeholder = document.createElement('div')
			placeholder.className='placeholder';
			var reference = this.dragElm;
			placeholder.style.width=reference.offsetWidth+'px';
			placeholder.style.height=reference.offsetHeight+'px';
		}
		// return;
		var reference = this.siblings[newIndex];
		if(reference){
			this.parentNode.insertBefore(placeholder,reference);
		} else {
			this.parentNode.appendChild(placeholder);
		}


	}


}

export default Draggable;
